import { render } from "./place.vue?vue&type=template&id=6e022c9c&scoped=true"
import script from "./place.vue?vue&type=script&lang=js"
export * from "./place.vue?vue&type=script&lang=js"

import "./place.vue?vue&type=style&index=0&id=6e022c9c&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e022c9c"]])

export default __exports__